import { isAdminOfEnterprise } from './isAdminOfEnterprise';

export const isAdminOfAnyEnterprise = (
  member: {
    id: string;
    idPremOrgsAdmin: string[];
    idEnterprise?: string | null;
    idEnterprisesAdmin: string[];
  },
  organizations: {
    id: string;
    idEnterprise?: string | null;
  }[],
) => {
  if (member.idEnterprise && isAdminOfEnterprise(member, member.idEnterprise)) {
    return true;
  }

  const organizationMap = new Map<
    string,
    { id: string; idEnterprise?: string | null }
  >();
  for (const organization of organizations) {
    organizationMap.set(organization.id, organization);
  }

  return member.idPremOrgsAdmin.some(
    (idOrganization) =>
      organizationMap.get(idOrganization)?.idEnterprise === member.idEnterprise,
  );
};
